import { PayPalMessages, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { type ReactElement, useMemo } from 'react';

export interface PaypalInstallmentsMessageProps {
    amount: number;
    placement: 'product' | 'cart';
    buyerCountry: string;
    clientId: string;
}

/**
 * PayPal Messages SDK installment banner (legacy SFCC `data-pp-message` path).
 */
export default function PaypalInstallmentsMessage({
    amount,
    placement,
    buyerCountry,
    clientId,
}: PaypalInstallmentsMessageProps): ReactElement | null {
    const scriptOptions = useMemo(
        () => ({
            clientId,
            components: 'messages',
            buyerCountry,
        }),
        [buyerCountry, clientId]
    );

    if (!clientId || amount <= 0) {
        return null;
    }

    return (
        <PayPalScriptProvider options={scriptOptions}>
            <div data-testid="paypal-installments-message">
                <PayPalMessages
                    amount={amount}
                    placement={placement}
                    className="r-installments-paypal_sdk"
                    style={{
                        layout: 'text',
                        logo: { type: 'none' },
                        text: { color: 'black', size: 12 },
                    }}
                    forceReRender={[amount, placement, buyerCountry]}
                />
            </div>
        </PayPalScriptProvider>
    );
}
